import React from 'react';
import { Calendar, Clock, MapPin, ArrowUpRight, Mail, Drum, Sparkles } from 'lucide-react';

const Meta = ({ icon: Icon, children }) => (
  <span className="inline-flex items-center gap-2 text-[#cdd2dc] text-sm">
    <Icon className="w-4 h-4 text-[#e8743b] shrink-0" /> {children}
  </span>
);

// Full featured-event block (image, details, workshops, practical info).
const FeaturedEvent = ({ event }) => (
  <>
    <div className="grid lg:grid-cols-2 gap-10 items-start">
      <div className="rounded-3xl overflow-hidden border border-white/10 relative">
        <img src={event.image} alt={event.title} className="w-full h-[340px] lg:h-[460px] object-cover" />
        <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#e8743b] text-white text-xs font-semibold">
          <Sparkles className="w-3.5 h-3.5" /> {event.badge}
        </span>
      </div>
      <div>
        <span className="dctv-eyebrow text-[#e8743b]">{event.scope} · {event.edition}</span>
        <h2 className="mt-3 font-serif-dctv text-4xl font-bold text-white">{event.title}</h2>
        <p className="mt-3 text-[#f4965a] font-medium italic">{event.theme}</p>
        {event.organiser && (
          <p className="mt-3 text-[#9aa3b2] text-sm">
            An event by <span className="text-white font-medium">{event.organiser}</span> - proudly promoted by Diaspora Community TV.
          </p>
        )}
        <div className="flex flex-col gap-2.5 mt-6">
          <Meta icon={Calendar}>{event.date}</Meta>
          <Meta icon={Clock}>{event.time}</Meta>
          <Meta icon={MapPin}>{event.venue} - {event.address}</Meta>
        </div>
        <p className="mt-6 text-[#9aa3b2] leading-relaxed">{event.intro}</p>
        <div className="flex flex-wrap gap-3 mt-7">
          <a href={event.website} target="_blank" rel="noopener noreferrer" className="dctv-btn-primary inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold">
            Full programme <ArrowUpRight className="w-4 h-4" />
          </a>
          <a href={`mailto:${event.signupEmail}`} className="dctv-btn-ghost inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold">
            <Mail className="w-4 h-4" /> Sign up for workshops
          </a>
        </div>
      </div>
    </div>

    <div className="mt-12">
      <h3 className="font-serif-dctv text-2xl font-bold text-white flex items-center gap-2">
        <Drum className="w-5 h-5 text-[#e8743b]" /> Free workshops - sign up now
      </h3>
      <div className="grid sm:grid-cols-2 gap-5 mt-6">
        {event.workshops.map((w) => (
          <div key={w.name} className="dctv-card rounded-2xl p-7">
            <h4 className="font-serif-dctv text-xl font-semibold text-white">{w.name}</h4>
            <p className="text-[#9aa3b2] text-sm leading-relaxed mt-3">{w.text}</p>
          </div>
        ))}
      </div>
    </div>

    <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
      {event.info.map((it) => (
        <div key={it.title} className="rounded-2xl border border-white/10 bg-[#111726] p-6">
          <p className="font-serif-dctv text-lg font-semibold text-white">{it.title}</p>
          <p className="text-[#9aa3b2] text-sm leading-relaxed mt-2">{it.text}</p>
        </div>
      ))}
    </div>
  </>
);

export default FeaturedEvent;
